<angular-editor
  #angularEditorComponent
  class="angular-editor"
  [config]="config"
  [(ngModel)]="selectedValue"
  (ngModelChange)="propagateChange(selectedValue)"
  [disabled]="isDisabled"
></angular-editor>
